/**
 * Normalize the public "location" filter for /search:
 * - 5-digit or ZIP+4 only → normalized zip string
 * - "12345 - City, ST" (from zip picker) → zip portion
 * - Anything else → trimmed free text (city, neighborhood, "Miami FL", etc.)
 */
export function normalizeLocationFilterInput(raw: string): string {
  const t = raw.trim().replace(/\s+/g, ' ');
  if (!t) return '';

  // Exact ZIP or ZIP+4
  const exactZip = t.match(/^(\d{5})(-\d{4})?$/);
  if (exactZip) {
    return exactZip[1] + (exactZip[2] || '');
  }

  // "12345 - City, State" (picker format)
  const zipThenLabel = t.match(/^(\d{5})(-\d{4})?\s*-\s*.+$/);
  if (zipThenLabel) {
    return zipThenLabel[1] + (zipThenLabel[2] || '');
  }

  // Everything else: city, neighborhood, "Miami FL", etc. (sent as-is to the search API)
  return t;
}
